import React from 'react';
import CardList from '../components/CardsList';

const TelaPrincipal = ({ dataCards, abrirCard }) => {

  const renderCardRow = (items) => (
    <div className="row">
      {items.map((item) => {
        const infoCard = dataCards[item.tipo] ?? null;

        return (
          <div key={item.tipo} className="col-md-3" onClick={() => abrirCard(item.tipo)}>
            {item.card({ infoCard })}
          </div>
        );
      })}
    </div>
  );

  return (
    <>
      {renderCardRow(CardList.slice(0, 4))}
      {renderCardRow(CardList.slice(4, 8))}
    </>
  );
};

export default TelaPrincipal;